import { AccountHolderRatePlan } from "../../services/accountService";
import { RatePlan, RatePlanType } from "./RatePlans";
import RatePlanList from "./RatePlanList";

type Props = {
  accountHolderCode: string;
  accountHolderId: string;
  accountHolderRatePlans: AccountHolderRatePlan[];
  ratePlanType: RatePlanType;
  isMasterSurchargeEnabled: boolean;
  isLoading: boolean;
  isEditing: boolean;
};

function FlatRatePlans({
  accountHolderCode,
  accountHolderId,
  accountHolderRatePlans,
  ratePlanType,
  isMasterSurchargeEnabled,
  isLoading,
  isEditing,
}: Props): JSX.Element {
  return (
    <div className="flex flex-shrink-0 flex-col flex-wrap">
      <div className="mb-3">
        <RatePlanList
          accountHolderCode={accountHolderCode}
          accountHolderId={accountHolderId}
          accountHolderRatePlans={accountHolderRatePlans}
          ratePlanType={ratePlanType}
          isMasterSurchargeEnabled={isMasterSurchargeEnabled}
          isLoading={isLoading}
          isEditing={isEditing}
        />
      </div>
    </div>
  );
}

export default FlatRatePlans;
